var _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaveButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_19_15",
    "data-name": "Component 19 \\u2013 15",
    xmlns: "http://www.w3.org/2000/svg",
    width: 129,
    height: 63,
    viewBox: "0 0 129 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    fill: "none",
    stroke: "#5aa5ef",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129,
    height: 63,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 127,
    height: 61,
    rx: 9,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Movie_Info",
    "data-name": "Movie Info",
    transform: "translate(-64 107.5)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_2019_-_Drama_-_120_m",
    "data-name": "2019 - Drama - 120 m",
    transform: "translate(109 -70.5)",
    fill: "#020410",
    fontSize: 16,
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Save")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveButton);
export default __webpack_public_path__ + "static/media/saveButton.3807e9c0.svg";
export { ForwardRef as ReactComponent };